var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000915527,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7699 15.4408C25.7804 15.6251 25.6291 15.7858 25.4286 15.7858H16.5714C16.3742 15.7858 16.2143 15.6259 16.2143 15.4287V6.57152C16.2143 6.371 16.375 6.21972 16.5594 6.23013C21.5173 6.51021 25.49 10.4916 25.7699 15.4408Z",
    fill: "url(#paint0_linear_22_689)",
    stroke: "white",
    strokeWidth: 0.428571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 25.7858C16.3709 25.7858 16.2196 25.6251 16.2301 25.4408C16.51 20.4916 20.4827 16.5102 25.4406 16.2301C25.625 16.2197 25.7857 16.371 25.7857 16.5715V25.4287C25.7857 25.6259 25.6258 25.7858 25.4286 25.7858H16.5714Z",
    fill: "url(#paint1_linear_22_689)",
    stroke: "white",
    strokeWidth: 0.428571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7857 25.4287C15.7857 25.6292 15.625 25.7805 15.4406 25.7701C10.4822 25.4906 6.50944 21.5179 6.23001 16.5595C6.21962 16.3751 6.37092 16.2144 6.57143 16.2144H15.4286C15.6258 16.2144 15.7857 16.3743 15.7857 16.5715V25.4287Z",
    fill: "#0168FF",
    stroke: "white",
    strokeWidth: 0.428571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55939 15.7701C6.37504 15.7805 6.21429 15.6292 6.21429 15.4287V6.57152C6.21429 6.37428 6.37418 6.21438 6.57143 6.21438H15.4286C15.6291 6.21438 15.7804 6.37513 15.77 6.55948C15.4906 11.5179 11.5178 15.4906 6.55939 15.7701Z",
    fill: "url(#paint2_linear_22_689)",
    stroke: "white",
    strokeWidth: 0.428571
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_689",
    x1: 26,
    y1: 6.00009,
    x2: 16,
    y2: 6.00009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_689",
    x1: 26,
    y1: 16.0001,
    x2: 16,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_689",
    x1: 16,
    y1: 6.00009,
    x2: 6,
    y2: 6.00009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8E5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.065214f4f82fc5aa9414b3ac73b9253a.svg";
export { ForwardRef as ReactComponent };